<template>
    <v-img
        class="cursor-pointer rounded-sm"
        @click="openNewWindow(src)"
        :max-width="width"
        contain
        :src="src"
        :width="width"
    >
        <template v-slot:placeholder>
            <v-skeleton-loader class="mx-auto border" :max-width="width" type="image"></v-skeleton-loader>
        </template>
        <template v-slot:error>
            <img src="/images/image_placeholder.svg" />
        </template>
    </v-img>
</template>
<script>
    export default {
        props: {
            src: null,
            width: {
                default: 200,
            },
        },
        methods: {
            openNewWindow(url) {
                window.open(url, '_blank')
            },
        },
    }
</script>
